export enum WeftSelectionType {
  TOP_RAPIER,
  MIDDLE_RAPIER,
  BOTTOM_RAPIER,
  PICK_DENSITY
}
